<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" md="12" sm="12">
        <iq-card class-name="iq-card-block iq-card-stretch" body-class="">
          <template v-slot:body>
            <b-row>
              <b-col lg="6" md="6" sm="6">
                <label class="typo__label">Dealer/s</label>
                <multiselect
                  v-model="selectedDealers"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a dealer"
                  label="name"
                  track-by="id"
                  :options="getDealerDropdown"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch iq-card-height"
          body-class="row m-0 align-items-center pb-0 mb-4"
        >
          <template v-slot:headerTitle>
            <div>
              <b-button
                class="mr-2"
                :class="{ primary: getDAdminRecordType == 'quotes' }"
                @click="fnSelectRecordType('quotes')"
                >Quotes</b-button
              >
              <b-button
                class="mr-2"
                :class="{ primary: getDAdminRecordType == 'leads' }"
                @click="fnSelectRecordType('leads')"
                >Leads</b-button
              >

              <b-spinner
                v-if="getDAdminIsDashboardLoading"
                label="Loading..."
                small
              ></b-spinner>
            </div>
          </template>
          <template v-slot:headerAction>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getDAdminPeriodMode == 'this-month' }"
                  @click="fnPeriod('this-month')"
                  >This month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getDAdminPeriodMode == 'last-month' }"
                  @click="fnPeriod('last-month')"
                  >Last month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getDAdminPeriodMode == 'this-year' }"
                  @click="fnPeriod('this-year')"
                  >This year</a
                >
              </li>
            </ul>
          </template>
          <template v-slot:body>
            <b-col md="12">
              <b-row>
                <b-col md="8">
                  <div
                    v-if="
                      getDAdminPeriodMode == 'this-month' &&
                      dataObj1 &&
                      dataObj1.labels
                    "
                  >
                    <appBarChart :dataObj="dataObj1"></appBarChart>
                  </div>
                  <div
                    v-if="
                      getDAdminPeriodMode == 'last-month' &&
                      dataObj2 &&
                      dataObj2.labels
                    "
                  >
                    <appBarChart :dataObj="dataObj2"></appBarChart>
                  </div>
                  <div
                    v-if="
                      getDAdminPeriodMode == 'this-year' &&
                      dataObj3 &&
                      dataObj3.labels
                    "
                  >
                    <appBarChart :dataObj="dataObj3"></appBarChart>
                  </div>
                </b-col>

                <b-col md="4" v-if="getDAdminRecordType == 'quotes'">
                  <appWDDashboardSummary
                    v-if="getDAdminPeriodMode == 'this-month' && dataObj1"
                    :dataObj="dataObj1"
                    :periodMode="'this-month'"
                    :isRecordType="getDAdminRecordType"
                  ></appWDDashboardSummary>

                  <appWDDashboardSummary
                    v-if="getDAdminPeriodMode == 'last-month' && dataObj2"
                    :dataObj="dataObj2"
                    :periodMode="'last-month'"
                    :isRecordType="getDAdminRecordType"
                  ></appWDDashboardSummary>

                  <appWDDashboardSummary
                    v-if="getDAdminPeriodMode == 'this-year' && dataObj3"
                    :dataObj="dataObj3"
                    :periodMode="'this-year'"
                    :isRecordType="getDAdminRecordType"
                  ></appWDDashboardSummary>
                </b-col>

                <!-- All Leads status -->
                <b-col
                  md="4"
                  v-if="
                    getDAdminAllLeadsStatus && getDAdminRecordType == 'leads'
                  "
                >
                  <WDDashboardAllLeadsStatus
                    v-if="getDAdminAllLeadsStatus"
                    :dataAllLeadsStatus="getDAdminAllLeadsStatus"
                  ></WDDashboardAllLeadsStatus>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="12">
              <b-row>
                <b-col
                  md="3"
                  v-if="
                    dataObj1.dataNAFBrakeDown ||
                    dataObj2.dataNAFBrakeDown ||
                    dataObj3.dataNAFBrakeDown
                  "
                >
                  <WDDashboardNAFBrakeDown
                    v-if="getDAdminPeriodMode == 'this-month' && dataObj1"
                    :dataNAFBrakeDown="dataObj1.dataNAFBrakeDown"
                  ></WDDashboardNAFBrakeDown>

                  <WDDashboardNAFBrakeDown
                    v-if="getDAdminPeriodMode == 'last-month' && dataObj2"
                    :dataNAFBrakeDown="dataObj2.dataNAFBrakeDown"
                  ></WDDashboardNAFBrakeDown>

                  <WDDashboardNAFBrakeDown
                    v-if="getDAdminPeriodMode == 'this-year' && dataObj3"
                    :dataNAFBrakeDown="dataObj3.dataNAFBrakeDown"
                  ></WDDashboardNAFBrakeDown>
                </b-col>

                <!-- All Quote status -->
                <b-col
                  md="3"
                  v-if="
                    getDAdminAllQuoteStatus && getDAdminRecordType == 'quotes'
                  "
                >
                  <WDDashboardAllQuoteStatus
                    v-if="getDAdminAllQuoteStatus"
                    :dataAllQuoteStatus="getDAdminAllQuoteStatus"
                  ></WDDashboardAllQuoteStatus>
                </b-col>
              </b-row>
            </b-col>
          </template>
        </iq-card>
      </b-col>

      <!-- Video guide -->
      <b-col lg="12">
        <iq-card class-name="iq-card-block iq-card-stretch iq-card-height">
          <template v-slot:headerTitle>
            <h4 class="card-title">Video guide</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="2" v-for="(video, index) in videos" :key="index">
                <appVideoPlaceHolder
                  :title="video.title"
                  :coverImgUrl="video.imageUrl"
                  :videoUrl="video.url"
                ></appVideoPlaceHolder>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from 'moment'
import bgImage from '../../assets/images/page-img/45.png'
import appVideoPlaceHolder from '../../components/wd/VideoPlaceHolder.vue'
import { mapGetters, mapActions } from 'vuex'
import appChartBox from '../../components/charts/ChartBox.vue'
import appBarChart from '../../components/charts/BarChart.vue'
import appWDDashboardSummary from '../../components/wd/WDDashboardSummary.vue'
import WDDashboardNAFBrakeDown from '../../components/wd/WDDashboardNAFBrakeDown.vue'
import WDDashboardAllQuoteStatus from '../../components/wd/WDDashboardAllQuoteStatus.vue'
import WDDashboardAllLeadsStatus from '../../components/wd/WDDashboardAllLeadsStatus.vue'

import {
  fnGetThisMonthData,
  fnGetLastMonthData,
  fnGetDashboardInformation,
  fnGetThisMonthLeadsData,
  fnGetLastMonthLeadsData,
  fnGetDashboardLeadsInformation
} from '../../Utils/dashboardAdmin'

export default {
  name: 'DashboardAdmin',
  components: {
    appVideoPlaceHolder,
    appChartBox,
    appBarChart,
    appWDDashboardSummary,
    WDDashboardNAFBrakeDown,
    WDDashboardAllQuoteStatus,
    WDDashboardAllLeadsStatus
  },
  data() {
    return {
      videos: [
        {
          title: 'What is a Novated Lease',
          imageUrl: require('../../assets/images/video-tutorials/f1.jpg'),
          url: '/videos/music_novated_lease_explained.mp4'
        },
        {
          title: 'Save Tax & GST',
          imageUrl: require('../../assets/images/video-tutorials/f2.jpg'),
          url: '/videos/novated_lease_savings.mp4'
        },
        {
          title: 'SA Government Employees',
          imageUrl: require('../../assets/images/video-tutorials/f3.jpg'),
          url: '/videos/sa_government_employees.mp4'
        },
        {
          title: 'Options at the end of the lease',
          imageUrl: require('../../assets/images/video-tutorials/f4.jpg'),
          url: '/videos/options_at_the_end_of_the_lease.mp4'
        },
        {
          title: 'Which employees can we assist',
          imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
          url: '/videos/which_employees_can_we_asist_with_novated_leasing.mp4'
        }
        // {
        //   title: 'Move Your Body',
        //   imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
        //   url: 'https://www.youtube.com/watch?v=fNfe6WdXRdA'
        // },
        // {
        //   title: 'Try New Things',
        //   imageUrl: require('../../assets/images/video-tutorials/f6.jpg'),
        //   url: 'https://www.youtube.com/watch?v=s4ObxcdXoFE'
        // }
      ],
      selectedDealers: '',
      dataSettlements: [],
      dataObj1: '',
      dataObj2: '',
      dataObj3: '',
      bgImageURL: bgImage,
      userObj: {},
      currentMonthInText: '',
      lastMonthInText: '',
      currentYearInText: ''
    }
  },
  computed: {
    ...mapGetters([
      'getDAdminRecordType',
      'getDAdminPeriodMode',
      'getDAdminIsDashboardLoading',
      'getDealerDropdown',
      'getDAdminThisMonthData',
      'getDAdminLastMonthData',
      'getDAdminLastYearData',
      'getDAdminThisMonthLeadsData',
      'getDAdminLastMonthLeadsData',
      'getDAdminLastYearLeadsData',
      'getUserById',
      'getDAdminAllQuoteStatus',
      'getDAdminAllLeadsStatus'
    ])
  },
  methods: {
    ...mapActions([
      'fetchDAdminRecordType',
      'fetchDAdminPeriodMode',
      'fetchDealerDropdown',
      'fetchDAdminThisMonthData',
      'fetchDAdminLastMonthData',
      'fetchDAdminLastYearData',
      'fetchDAdminAllQuoteStatusData',
      'fetchDAdminAllLeadsStatusData',
      'fetchDAdminThisMonthLeadsData',
      'fetchDAdminLastMonthLeadsData',
      'fetchDAdminLastYearLeadsData'
    ]),

    fnSelectRecordType(recordType) {
      this.fetchDAdminRecordType(recordType)
      this.fnPeriod(this.getDAdminPeriodMode)
    },

    // This month data
    fnPeriodThisMonth() {
      let thisMonthData = fnGetThisMonthData(
        this.getDAdminThisMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisMonthData.dataTotSettlement,
        dataTotInc: thisMonthData.dataTotInc,
        dataTotVSAIncome: thisMonthData.dataTotVSAIncome,
        dataTotNAF: thisMonthData.dataTotNAF,
        dataNAFBrakeDown: thisMonthData.dataNAFBrakeDown,
        dataTotVolumeBones: thisMonthData.dataTotVolumeBones,
        dataAverageIncomePerContract:
          thisMonthData.dataAverageIncomePerContract,
        dataAverageNAFPerContract: thisMonthData.dataAverageNAFPerContract
      }
      this.dataObj1 = obj
    },

    // Last month data
    fnPeriodLastMonth() {
      let lastMonthData = fnGetLastMonthData(
        this.getDAdminLastMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: lastMonthData.dataTotSettlement,
        dataTotInc: lastMonthData.dataTotInc,
        dataTotVSAIncome: lastMonthData.dataTotVSAIncome,
        dataTotNAF: lastMonthData.dataTotNAF,
        dataNAFBrakeDown: lastMonthData.dataNAFBrakeDown,
        dataTotVolumeBones: lastMonthData.dataTotVolumeBones,
        dataAverageIncomePerContract:
          lastMonthData.dataAverageIncomePerContract,
        dataAverageNAFPerContract: lastMonthData.dataAverageNAFPerContract
      }
      this.dataObj2 = obj
    },

    // Last year data
    fnPeriodLastYear() {
      let thisYearData = fnGetDashboardInformation(
        this.getDAdminLastYearData.data_settlement_quote
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisYearData.dataTotSettlement,
        dataTotInc: thisYearData.dataTotInc,
        dataTotVSAIncome: thisYearData.dataTotVSAIncome,
        dataTotNAF: thisYearData.dataTotNAF,
        dataNAFBrakeDown: thisYearData.dataNAFBrakeDown,
        dataTotVolumeBones: thisYearData.dataTotVolumeBones,
        dataAverageIncomePerContract: thisYearData.dataAverageIncomePerContract,
        dataAverageNAFPerContract: thisYearData.dataAverageNAFPerContract
      }
      this.dataObj3 = obj
    },

    // This month all Leads
    fnPeriodThisMonthLeads() {
      let thisMonthData = fnGetThisMonthLeadsData(
        this.getDAdminThisMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisMonthData.dataTotQuotes
      }
      this.dataObj1 = obj
    },

    // Last month all Leads
    fnPeriodLastMonthLeads() {
      let lastMonthData = fnGetLastMonthLeadsData(
        this.getDAdminLastMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: lastMonthData.dataTotQuotes
      }
      this.dataObj2 = obj
    },

    // Last year all Leads
    fnPeriodLastYearLeads() {
      let thisYearData = fnGetDashboardLeadsInformation(
        this.getDAdminLastYearLeadsData.data
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisYearData.dataTotQuotes
      }
      this.dataObj3 = obj
    },

    async fnPeriod(periodMode) {
      await this.fetchDAdminPeriodMode(periodMode)

      if (
        this.getDAdminRecordType == 'quotes' &&
        this.getDAdminPeriodMode == 'this-month'
      ) {
        this.fnPeriodThisMonth()

        return
      }

      if (
        this.getDAdminRecordType == 'quotes' &&
        this.getDAdminPeriodMode == 'last-month'
      ) {
        this.fnPeriodLastMonth()
        return
      }

      if (
        this.getDAdminRecordType == 'quotes' &&
        this.getDAdminPeriodMode == 'this-year'
      ) {
        this.fnPeriodLastYear()
        return
      }

      if (
        this.getDAdminRecordType == 'leads' &&
        this.getDAdminPeriodMode == 'this-month'
      ) {
        this.fnPeriodThisMonthLeads()
        return
      }

      if (
        this.getDAdminRecordType == 'leads' &&
        this.getDAdminPeriodMode == 'last-month'
      ) {
        this.fnPeriodLastMonthLeads()
        return
      }

      if (
        this.getDAdminRecordType == 'leads' &&
        this.getDAdminPeriodMode == 'this-year'
      ) {
        this.fnPeriodLastYearLeads()
        return
      }
    }
  },
  async created() {
    await this.fetchDealerDropdown()
    await this.fetchDAdminRecordType('quotes')
    await this.fetchDAdminThisMonthData({
      selectedDealers: this.selectedDealers
    })
    await this.fetchDAdminLastMonthData({
      selectedDealers: this.selectedDealers
    })
    await this.fetchDAdminLastYearData({
      selectedDealers: this.selectedDealers
    })

    await this.fetchDAdminThisMonthLeadsData({
      selectedDealers: this.selectedDealers
    })
    await this.fetchDAdminLastMonthLeadsData({
      selectedDealers: this.selectedDealers
    })
    await this.fetchDAdminLastYearLeadsData({
      selectedDealers: this.selectedDealers
    })

    this.currentMonthInText = moment().format('MMMM')
    this.lastMonthInText = moment().subtract(1, 'month').format('MMMM')
    this.currentYearInText = moment().format('YYYY')

    await this.fnPeriod(this.getDAdminPeriodMode)

    await this.fetchDAdminAllQuoteStatusData({
      selectedDealers: this.selectedDealers
    })

    await this.fetchDAdminAllLeadsStatusData({
      selectedDealers: this.selectedDealers
    })
  },
  watch: {
    async selectedDealers(val) {
      await this.fetchDAdminThisMonthData({ selectedDealers: val })
      await this.fetchDAdminLastMonthData({ selectedDealers: val })
      await this.fetchDAdminLastYearData({ selectedDealers: val })

      await this.fetchDAdminThisMonthLeadsData({ selectedDealers: val })
      await this.fetchDAdminLastMonthLeadsData({ selectedDealers: val })
      await this.fetchDAdminLastYearLeadsData({ selectedDealers: val })

      await this.fnPeriod(this.getDAdminPeriodMode)
    }
  }
}
</script>

<style lang="scss" scoped>
.iq-card-body {
  flex: unset;
}
.btn.btn-secondary {
  background-color: var(--iq-light-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-primary);
}
.btn.btn-secondary.primary {
  background-color: var(--iq-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-white);
}
</style>
